export const GENRES = [
  "Reguetón", "Bachata", "Merengue", "Dembow", "Trap Latino", "Salsa",
  "Bolero", "Corrido", "Pop Latino", "Synthwave", "Cinematic Rock", "Flamenco", "Lo-fi", "Balada",
];

export const VOICES = [
  { id: "mine", label: "Mi voz" },
  { id: "male", label: "Voz masculina" },
  { id: "female", label: "Voz femenina" },
  { id: "duo", label: "Dúo (h + m)" },
  { id: "choir", label: "Con coro" },
];

export const VIDEO_STYLES = [
  { id: "cinematic", label: "Cinematográfico" },
  { id: "hyper-realistic", label: "Realista" },
  { id: "anime", label: "Anime" },
  { id: "cyberpunk", label: "Cyberpunk" },
  { id: "music video", label: "Video musical" },
  { id: "documentary", label: "Documental" },
];

export const VIDEO_DURATIONS = [
  { id: "6", label: "6 seg" },
  { id: "10", label: "10 seg" },
];
